import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Stepper from '../Stepper';
import { RootState } from '../../../store';
import { updateValidForm, updateValidStep } from '../../../features/stepper/stepper-slice';
import { savePersonalDataByKey } from '../../../features/personalData/personalData-slice';
import userQuickAccessUserVerify from '../../../domain/userQuickAccessUserVerify';
import PageLoading from '../Loading';
import { TextFieldCPF } from '../../shared/TextFieldCPF';
import { dynamicCustomEventTracking } from '../../../lib/gtm';

type QuickAccessFormFields = {
  oyana: {
    cpf: string;
  };
};

const QuickAccessForm = () => {
  const form = useForm<QuickAccessFormFields>();
  const { nextPage } = useSelector((state: RootState) => state);
  const { handleUserVerify, oyanaRecurrentIsLoading, signInMethodIsLoading } = userQuickAccessUserVerify();
  const dispatch = useDispatch();
  const [valid, setValid] = useState(false);
  const valueRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    dispatch(
      updateValidStep({
        quickAccess: valid
      })
    );
    if (valid && valueRef.current) {
      dispatch(
        savePersonalDataByKey({
          key: 'cpf',
          value: valueRef.current
        })
      );
    }
  }, [valid, valueRef]);

  useEffect(() => {
    if (nextPage.validForm.quickAccess.valid) {
      dynamicCustomEventTracking.send({ dynamicEventName: `journey_quick_access_cpf_valid_ag` });
      dispatch(updateValidForm({ quickAccess: { valid: false } }));
      handleUserVerify();
    }
  }, [nextPage.validForm.quickAccess.valid]);

  return (
    <Grid container>
      <Grid item xs={12}>
        {(oyanaRecurrentIsLoading || signInMethodIsLoading) && <PageLoading />}

        <Box sx={{ mb: 4 }}>
          <Stepper separator="de" text="Dados pessoais" />
        </Box>
        <Box sx={{ mb: 5 }}>
          <Typography variant="h3">Preencha seus dados</Typography>
        </Box>
      </Grid>
      <Grid item xs={12} sx={{ mb: 7 }}>
        <Typography variant="body6" sx={{ mb: 0.5 }}>
          CPF*
        </Typography>
        <TextFieldCPF
          form={form}
          name="oyana.cpf"
          onValidityChange={(isValid: boolean) => setValid(isValid)}
          onChange={(value: string) => {
            valueRef.current = value;
          }}
        />
      </Grid>
    </Grid>
  );
};

export default QuickAccessForm;
